module.exports = __webpack_public_path__ + "front/img/25.ecf471ec.png";